import { StyleSheet } from 'react-native';

const styles: any = StyleSheet.create({
	container: {
		backgroundColor: '#6fb3e0' //'#FBFAFA'
	},
	row: {
		flex: 1,
		alignItems: 'center'
	},
	text: {
		fontSize: 20,
		marginBottom: 15,
		alignItems: 'center'
	},
	mt: {
		marginTop: 18
	},
	modalStyle: {
		borderRadius: 10,
		width: '90%',
		// height: '90%',
		maxHeight: '90%',
	},
	modalContainer: {
		//width: '100%',
		//justifyContent: 'center',
		backgroundColor: 'rgba(255,255,255,0)' //'#f8f8fc'
	},

	modalHeader: {
		height: 45,
		borderTopLeftRadius: 10,
		borderTopRightRadius: 10
	},

	bottomBtns: {
		//backgroundColor: '#295670',
		flexDirection: 'row'
	}
});
export default styles;
